module.exports = __webpack_public_path__ + "static/media/support10_large_banner.4b975501.jpg";